<script setup lang="ts">
import {ref} from "vue";
import {ArrowLeftBold} from "@element-plus/icons-vue";

defineProps({
    isBack: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "",
    }
});

const emit = defineEmits(["back"]);
const back = () => {
    emit("back");
};
</script>

<template>
    <div class="page-header">
        <div class="right">
            <div class="page-header-back" @click="back" v-if="isBack">
                <el-icon size="18px" style="margin-top: 3px;">
                    <ArrowLeftBold/>
                </el-icon>
            </div>
            <div
                :class="isBack ? 'page-header-mark' : 'page-header-mark-widen'"
            ></div>
            <span class="page-header-title">{{ title }}</span>
            <slot name="right"></slot>
        </div>
        <div class="left">
            <slot name="left"></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.page-header {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    padding: 10px 0;

    .right {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 1;

        .page-header-back {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }

        .page-header-mark {
            width: 1px;
            height: 20px;
            background-color: #dcdfe6;
            margin-left: 10px;
            margin-top: 3px;
        }

        .page-header-mark-widen {
            width: 0px;
            height: 20px;
            background-color: #409eff;
        }

        .page-header-title {
            margin-left: 10px;
            font-size: 21px;
        }
    }

    .left {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
